import { axiosInstance } from '../api';

export default function(userId, profileRequest) {
    return axiosInstance.put(`/api/users/${userId}/profile`, profileRequest);
}